module.exports = __webpack_public_path__ + "static/media/china.109b1d85.svg";